import React from 'react';
import PropTypes from 'prop-types';
import { get, slice } from 'lodash';
import { connect } from 'react-redux';
import { getQuestions } from '../actions';
import Question from './Question';

const mapStateToProps = state => ({
  questions: state.questions,
  submission: state.submission,
  next_question: state.next_question
});

const mapDispatchToProp = dispatch => ({
  onLoad: () => {
    dispatch(getQuestions());
  }
});

class Questions extends React.Component {
  constructor(props) {
    super(props);
    this.freqLoad = null;
  }

  componentWillMount() {
    this.props.onLoad();
  }

  componentDidMount() {
    this.freqLoad = setInterval(this.props.onLoad, 30000);
  }

  componentWillUnmount() {
    clearInterval(this.freqLoad);
  }

  componentDidUpdate() {
    const { next_question, submission, questions } = this.props;
    let num_questions = next_question;
    if (get(submission, 'submitted')) {
      num_questions = questions.length + 1;
    }

    const slides = document.getElementById('slides');
    const footer = document.getElementById('footer');
    const slidesWidth = 740 + 660 * num_questions + 660;
    if (slides) { slides.style.width = `${slidesWidth}px`; }
    if (footer) { footer.style.width = `${slidesWidth + 60}px`; }
  }

  render() {
    const { questions, next_question, submission } = this.props;

    const showingQuestions = get(submission, 'submitted', false) ? questions : slice(questions, 0, next_question);

    const questionSlides = showingQuestions.map((question, idx) => {
      return (
        <div key={ idx }>
          <Question question={ question } idx={ idx } />
        </div>
      );
    })

    return (
      <div>
        { questionSlides }
      </div>
    );
  }
}

Questions.propTypes = {
  questions: PropTypes.array,
  submission: PropTypes.object,
  next_question: PropTypes.number,
  onLoad: PropTypes.func,
};

const QuestionsContainer = connect(
  mapStateToProps,
  mapDispatchToProp
)(Questions);

export default QuestionsContainer;


// WEBPACK FOOTER //
// ./src/components/Questions.js